export default __webpack_public_path__ + "8e1c81a4177e61afccaa242ad54e1283.png";